/* eslint-disable @typescript-eslint/ban-ts-comment -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
class URL {
  private static instance: URL;
  private static protocol: string = "https://";
  public currentDomain: string = window.location.hostname;
  private _domain!: string;
  private _officeDomain!: string;
  private _isOuterScope!: boolean;

  constructor() {
    if (!URL.instance) {
      URL.instance = this;
      this.domain = this.currentDomain;
      this.officeDomain = this.currentDomain;
      this.isOuterScope = this.currentDomain;
    }
    return URL.instance;
  }

  get currentBaseURL() {
    return URL.protocol + this.currentDomain;
  }

  getCurrentFullURL(path: string) {
    return this.currentBaseURL + path;
  }

  set domain(hostname: string) {
    switch (true) {
      case hostname.includes("release.qubictron.dev"):
        this._domain = "release.qubictron.dev";
        break;
      case __LOCAL__:
      case hostname.includes("qubictron.dev"):
        this._domain = "develop.qubictron.dev";
        break;
      default:
        this._domain = "www.qubictron.com";
    }
  }

  get domain() {
    return this._domain;
  }

  get baseURL() {
    return URL.protocol + this.domain;
  }

  getFullURL(path: string) {
    return this.baseURL + path;
  }

  getIframeUrl(path: string) {
    const iframeExpandedParams = `?iframe=true`;

    return `?tr=${path}${iframeExpandedParams}`;
  }

  set officeDomain(hostname: string) {
    switch (true) {
      case hostname.includes("qubictron.loc"):
      case hostname.includes("qubictron.dev"):
        this._officeDomain = "office.qubictron.dev";
        break;
      default:
        this._officeDomain = "office.qubictron.com";
    }
  }

  get officeDomain() {
    return this._officeDomain;
  }

  get officeBaseURL() {
    return URL.protocol + this.officeDomain;
  }

  getOfficeFullURL(path: string) {
    return this.officeBaseURL + path;
  }

  set isOuterScope(hostname: string) {
    switch (hostname) {
      case "www.qubictron.loc":
      case "develop.qubictron.dev":
      case "release.qubictron.dev":
      case "www.qubictron.com":
        this._isOuterScope = false;
        break;
      default:
        this._isOuterScope = true;
    }
  }

  //@ts-ignore
  get isOuterScope(): boolean {
    return this._isOuterScope;
  }
}

export const url = new URL();
